import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${theme.shapes.borderRadius.sm};
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
  overflow: hidden;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.spacing.md};
  height: 35px;
  background-color: ${theme.colors.quartenary};

  span {
    font-family: ${theme.typography.family.primary};
    font-size: ${theme.typography.sizes.xs};
    color: ${theme.colors.neutral.high};
  }
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  background-color: ${theme.colors.neutral.white};
`
